

































import { Component, Prop, Vue } from "vue-property-decorator";
import VModal from "./VModal.vue";

@Component({
  components: {
    VModal,
  },
})
export default class CloseModal extends Vue {
  @Prop({ default: "" }) title?: string;
  @Prop({ default: "Messaggio positivo" }) positiveText?: string;
  @Prop({ default: "Messaggio negativo" }) negativeText?: string;

  modal!: VModal;
  content = "";

  confirmed!: any | null;
  aborted!: any | null;

  mounted() {
    this.modal = this.$refs.modal as VModal;
  }

  get hasContent(): boolean {
    return this.$slots.default != null;
  }

  protected onConfirm() {
    if (this.confirmed) {
      this.confirmed();
    }

    this.confirmed = null;
    this.modal.hide();
  }

  protected onAbort() {
    if (this.aborted) {
      this.aborted();
    }

    this.aborted = null;
    this.modal.hide();
  }

  protected onHidden() {
    if (this.confirmed) {
      this.confirmed();
    }
  }

  dialog(content: string | undefined = undefined): Promise<boolean> {
    this.modal.show();

    if (content) {
      this.content = content;
    }

    return new Promise((resolve) => {
      this.confirmed = () => {
        resolve(true);
      };

      this.aborted = () => {
        resolve(false);
      };
    });
  }
}
